import { createFileRoute, redirect } from '@tanstack/react-router';

/** The app has no dashboard; recipes are the centre of gravity (PLAN.md §1). */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/recipes' });
  },
});
